import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { timer } from 'rxjs';
import { Msg } from 'src/app/component/auth/model/user.model';
import { ConfirmChangesComponent } from 'src/app/component/common-components/confirm-changes/confirm-changes.component';

import { InputEmailService } from 'src/app/component/common-components/input-email/service/input-email.service';
import { City } from 'src/app/component/common-components/location/model/city.model';
import { PostalCode } from 'src/app/component/common-components/location/model/postal-code.model';
import { Region } from 'src/app/model/region.model';
//import { Region } from 'src/app/component/common-components/location/model/region.model';
import { State } from 'src/app/component/common-components/location/model/state.model';
import { InputOrganizationAutocompleteComponent } from 'src/app/component/common-components/organizations/input-organization-autocomplete/input-organization-autocomplete.component';
import { Organization } from 'src/app/component/common-components/organizations/model/organization.model';
import { RoleDataService } from 'src/app/component/common-components/service/role-data.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { GeographicalRegions } from 'src/app/component/party/model/geographicalRegions.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Role, RoleSelection } from 'src/app/model/roles';
import { AccountService } from '../service/account.service';
import { DistrictDropdownTwoWayComponent } from 'src/app/component/common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';

@Component({
    selector: 'app-create-accounts',
    templateUrl: './create-accounts.component.html',
    styleUrls: ['./create-accounts.component.scss']
})
export class CreateAccountsComponent implements OnInit {
    @ViewChild(MatAccordion) accordion: MatAccordion;
    @ViewChild(DistrictDropdownTwoWayComponent) districtDropDown!: DistrictDropdownTwoWayComponent;
    @ViewChild(InputOrganizationAutocompleteComponent) organizationAutoComplete: InputOrganizationAutocompleteComponent;
    districtRefresh: boolean = false;
    domainValidatorDbounce: any;
    createAccountForm: UntypedFormGroup;
    workDetailsForm: UntypedFormGroup;
    suffixes: string[] = ['Jr', 'Sr', 'II', 'III', 'IV', 'V', 'VI'];
    step = 0;

    city: City;
    state: State;
    zipcode: PostalCode;

    selectedRegion: Region;
    selectedRegions: Region[];
    selectedOrganization: Organization;
    geogrpahicRegion: GeographicalRegions[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];

    lstSelectedRole: Role[] = [];

    lstUserRoles: RoleSelection[] = [];
    lstApproverRole: RoleSelection[] = [];
    lstAdminRoles: RoleSelection[] = [];

    constructor(
        private fb: UntypedFormBuilder,
        private inputEmailService: InputEmailService,
        private accountService: AccountService,
        public roleDataService: RoleDataService,
        private accessService: AccessService,
        public dialog: MatDialog
    ) {
        this.accessService.getGeographical().subscribe((x) => {
            this.geogrpahicRegion = x;
        });
        this.city = new City();
        this.state = new State();
        this.zipcode = new PostalCode();

        this.selectedRegion = new Region();

        this.selectedOrganization = new Organization();

        this.createAccountForm = this.fb.group({
            firstName: ['', [Validators.required]],
            middleInitial: [''],
            lastName: ['', Validators.required],
            suffix: [''],
            workTitle: ['', Validators.required]
        });

        this.workDetailsForm = this.fb.group(
            {
                StreetAddress1: ['', Validators.required],
                StreetAddress2: [''],
                workPhoneNumber: ['', Validators.required],
                ext: [''],
                email: ['', [Validators.required, Validators.email], [this.emailDomainValidator.bind(this)]],
                confirmEmail: ['', [Validators.required, Validators.email]]
            },
            {
                validators: this.emailMustMatch()
            }
        );
    }

    ngOnInit(): void {
        this.districtRefresh = true;
        this.getRoles();
    }

    disableTabButton(tab: number) {
        if (tab == 0) {
            if (this.createAccountForm.valid) {
                return false;
            }
        } else if (tab == 1) {
            if (this.workDetailsForm.valid && this.city.ID! > 0 && this.state.ID! > 0 && this.zipcode.ID! > 0) {
                return false;
            }
        } else if (tab == 2) {
            if (this.selectedRegion?.ID! > 0) return false;
        } else if (tab == 3) {
            if (this.lstSelectedRole?.length > 0) return false;
        } else if (tab == 10) {
            if (
                this.createAccountForm.valid &&
                this.workDetailsForm.valid &&
                this.city.ID! > 0 &&
                this.state.ID! > 0 &&
                this.zipcode.ID! > 0 &&
                this.selectedRegion?.ID! > 0 &&
                this.lstSelectedRole?.length > 0
            )
                return false;
        }

        return true;
    }

    removeDistrict(districtId: number) {
        let lstSchoolDistrictId: number[] = this.lstSelecteddistricts.filter((x) => x.ID != districtId).map((y) => y.ID);

        if (lstSchoolDistrictId?.length > 0) {
            this.districtDropDown.deSelectAll();
            this.districtDropDown.select(lstSchoolDistrictId);
            this.districtDropDown.emitSelect(lstSchoolDistrictId);
        } else {
            this.districtDropDown.deSelectAll();
            this.districtDropDown.select([]);
            this.districtDropDown.emitSelect(lstSchoolDistrictId);
        }
    }
    removeAllDistricts() {
        this.lstSelecteddistricts = [];
        this.districtDropDown.deSelectAll();
        this.districtDropDown.select([]);
    }
    removeRoles() {
        this.lstUserRoles.map((x) => (x.selected = false));
        this.lstApproverRole.map((x) => (x.selected = false));
        this.lstAdminRoles.map((x) => (x.selected = false));
    }

    createAccount() {
        this.accountService.accountRegister(this.createUserDetailRequest()).subscribe((x) => {
            let msg: Msg = x['msg'];
            if (msg.SUCCESS) {
                this.city = new City();
                this.state = new State();
                this.zipcode = new PostalCode();
                this.selectedOrganization = {};
                this.lstSelectedRole = [];

                this.removeAllDistricts();
                this.removeRoles();
                this.createAccountForm.reset();
                this.workDetailsForm.reset();

                this.openDialog(msg.MSG!);
            } else {
                this.openDialog(msg.MSG!);
            }
        });
    }

    setStep(index: number) {
        this.step = index;
    }

    nextStep() {
        this.step++;
    }

    prevStep() {
        this.step--;
    }

    createUserDetailRequest() {
        let roleIds: RoleIds[] = [];

        this.lstSelectedRole.forEach((x) => {
            roleIds.push({ ROLES_ID: x.ID });
        });

        let selectedReg = this.selectedRegion;
        let sOrg = this.selectedOrganization;
        return {
            user_details: {
                SCHOOL_DISTRICTS: this.lstSelecteddistricts,
                REGION: selectedReg,
                WORK_TITLE: this.workTitle.value,
                EMAIL_ADDRESS: this.email.value,
                WORKS_FOR: sOrg,
                USER_ROLES: []
            },
            person: {
                FIRST_NAME: this.firstName.value,
                LAST_NAME: this.lastName.value,
                MIDDLE_INITIAL: this.middleInitial.value,
                SUFFIX: this.suffix.value
            },
            regions: [selectedReg],
            workAddress: {
                CITy: this.city,
                STREET_1: this.StreetAddress1.value,
                STREET_2: this.StreetAddress2?.value,
                GEOGRAPHICAL_REGIONS: this.geogrpahicRegion.find((x) => x.ID == 1),
                POSTAL_CODES: this.zipcode
            },
            workPhone: {
                PHONE_NUMBER: this.workPhoneNumber.value
            },
            partyRoleTypes: [
                {
                    ID: 1,
                    TYPE: 'Person',
                    DESCRIPTION: 'Person'
                }
            ],
            accountRequestRoles: roleIds,
            accountRequestId: 0
        };
    }

    openDialog(msg: string) {
        const dialogRef = this.dialog.open(ConfirmChangesComponent, {
            width: '500px',
            data: { msg: msg, showCancelBtn: false }
        });
    }

    getRoles() {
        this.lstUserRoles = [];
        this.lstApproverRole = [];
        this.lstAdminRoles = [];

        this.roleDataService.getAll().subscribe((roles: Role[]) => {
            roles = roles.filter((x) => x.ACTIVE != 0);
            roles
                .filter((x) => x.NAME.indexOf('Approver') < 0 && x.NAME.indexOf('Administrator') < 0)
                .sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                })
                .forEach((item) => {
                    this.lstUserRoles.push({ selected: false, role: item });
                });

            roles
                .filter((x) => x.NAME.indexOf('Approver') > 0)
                .sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                })
                .forEach((item) => {
                    this.lstApproverRole.push({ selected: false, role: item });
                });
            roles
                .filter((x) => x.NAME.indexOf('Administrator') > 0)
                .sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                })
                .forEach((item) => {
                    this.lstAdminRoles.push({ selected: false, role: item });
                });
        });
    }

    onChkChange(ob: MatCheckboxChange, role: Role) {
        if (ob.checked) {
            if (this.lstSelectedRole.findIndex((x) => x.ID == role.ID) < 0) {
                const r = {} as Role;
                r.ID = role.ID;
                this.lstSelectedRole.push(r);
            }
        } else {
            this.lstSelectedRole = this.lstSelectedRole.filter((x) => x.ID != role.ID);
        }
    }

    get firstName(): any {
        return this.createAccountForm.get('firstName');
    }
    get middleInitial(): any {
        return this.createAccountForm.get('middleInitial');
    }
    get lastName(): any {
        return this.createAccountForm.get('lastName');
    }
    get workTitle(): any {
        return this.createAccountForm.get('workTitle');
    }
    get suffix(): any {
        return this.createAccountForm.get('suffix');
    }

    get StreetAddress1(): any {
        return this.workDetailsForm.get('StreetAddress1');
    }
    get StreetAddress2(): any {
        return this.workDetailsForm.get('StreetAddress2');
    }
    get workPhoneNumber(): any {
        return this.workDetailsForm.get('workPhoneNumber');
    }
    get ext(): any {
        return this.workDetailsForm.get('ext');
    }

    get email(): any {
        return this.workDetailsForm.get('email');
    }
    get confirmEmail(): any {
        return this.workDetailsForm.get('confirmEmail');
    }

    emailDomainValidator(control: UntypedFormControl) {
        clearTimeout(this.domainValidatorDbounce);
        const q = new Promise((resolve, reject) => {
            this.domainValidatorDbounce = setTimeout(() => {
                this.inputEmailService.checkEmailDomain(control.value).subscribe((r: any) => {
                    let resp: Msg = r['msg'];
                    if (resp.SUCCESS) {
                        this.inputEmailService.emailExists(control.value).subscribe((r: any) => {
                            let resp: Msg = r['msg'];
                            if (!resp.SUCCESS) resolve(null);
                            else resolve({ domainValidator: { invalid: true, msg: resp.MSG } });
                        });
                    } else {
                        resolve({ domainValidator: { invalid: true, msg: resp.MSG } });
                    }
                });
            }, 1000);
        });
        return q;
    }
    emailMustMatch(): any {
        return (formGroup: UntypedFormGroup) => {
            const confirmEmail = formGroup.controls['confirmEmail'];
            if (formGroup.controls['email'].invalid) {
                formGroup.controls['confirmEmail'].setErrors(null);
                return;
            }
            if (formGroup.controls['email'].value !== formGroup.controls['confirmEmail'].value)
                formGroup.controls['confirmEmail'].setErrors({ emailMustMatch: true });
            else formGroup.controls['confirmEmail'].setErrors(null);
        };
    }
    // private emailDomainValidator(): AsyncValidatorFn {
    //     return (control: AbstractControl): Observable<ValidationErrors | null> => {
    //         return of(control.value).pipe(
    //             delay(500),
    //             switchMap((email) =>
    //                 this.inputEmailService
    //                     .checkEmailDomain(email)
    //                     .pipe(map((responseMessage) => (responseMessage.SUCCESS ? null : { emailDomailValidator: true })))
    //             )
    //         );
    //     };
    // }
}

export interface RoleIds {
    ROLES_ID: number;
}
